export { default as Histogram } from './Histogram';
